module.exports = __webpack_public_path__ + "static/media/price_img.f343b5e0.svg";